import React from 'react';
import './ForgotPasswordPage.scss';
import CustomForgotPassword from "../../forms/CustomForgotPassword/CustomForgotPassword";
import Hero from "../../common/Hero/Hero";
import {useTranslation} from "react-i18next";

const ForgotPasswordPage = (props) => {
  const match = props.match || props.computedMatch;
  const {token = null} = match.params;
  const {t} = useTranslation();
  const text = token ? t("forgot.password.page.description_operator") : t("forgot.password.page.description");
  return (
    <div className={"ForgotPassword"} data-testid={"ForgotPassword"}>
      <Hero backTo={'/login'}
            backToText={t("common.back.login")}
            title={t("forgot.password.hero_title")}
            description={text}/>
      <div className="container page-content-container">
        <CustomForgotPassword token={token}/>
      </div>
    </div>
  )
};

ForgotPasswordPage.propTypes = {};

export default ForgotPasswordPage;
